(function () {
  'use strict';

  // Nov 2026: the live-search dropdown (Shopify's native /search/suggest.json) always shows a
  // product's default image, even when the typed term matches a specific print/color variant
  // (e.g. a product with one "Design" option and many print variants sharing one listing).
  // That API returns no usable variant data, so this hooks the dropdown after it renders,
  // fetches the matched product's own variants (cheap, cached, only for products shown in the
  // dropdown), and swaps the thumbnail to the matching variant's photo. Fails silently; never
  // blocks or alters the dropdown's normal behavior.

  function normalize(str) {
    return (str || '').toString().toLowerCase().replace(/[-_\s]/g, '');
  }

  function sizedImageUrl(url) {
    return url.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, '_100x100_crop_center$1$2');
  }

  function matchVariantImageUrl(query, variants) {
    var qn = normalize(query);
    if (!qn || !variants || variants.length < 2) return null;

    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var skuN = normalize(v.sku);
      if (skuN && (qn.indexOf(skuN) !== -1 || skuN.indexOf(qn) !== -1)) {
        if (v.featured_image && v.featured_image.src) return v.featured_image.src;
      }
    }

    for (var j = 0; j < variants.length; j++) {
      var v2 = variants[j];
      var designN = normalize((v2.title || '').split(' / ')[0]);
      if (designN && (qn.indexOf(designN) !== -1 || designN.indexOf(qn) !== -1)) {
        if (v2.featured_image && v2.featured_image.src) return v2.featured_image.src;
      }
    }

    return null;
  }

  var productCache = {};
  function fetchProductByHandle(handle) {
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .catch(function () { return null; });
    return productCache[handle];
  }

  function fixThumbnails(resultsEl, query) {
    if (!query) return;
    var links = resultsEl.querySelectorAll('a.search-result[href*="/products/"]');
    links.forEach(function (link) {
      var href = link.getAttribute('href') || '';
      var match = href.match(/\/products\/([^/?#]+)/);
      if (!match) return;
      var handle = match[1];

      fetchProductByHandle(handle).then(function (product) {
        if (!product || !product.variants || product.variants.length < 2) return;
        var imageUrl = matchVariantImageUrl(query, product.variants);
        if (!imageUrl) return;
        var img = link.querySelector('.search-result__image img');
        if (img) {
          img.src = sizedImageUrl(imageUrl);
        }
      }).catch(function () {});
    });
  }

  function init() {
    var resultsContainers = document.querySelectorAll('.search-bar__results');
    if (!resultsContainers.length) return;

    resultsContainers.forEach(function (resultsEl) {
      var bar = resultsEl.closest('.search-bar');
      var observer = new MutationObserver(function () {
        try {
          var input = bar ? bar.querySelector('input[name="q"]') : null;
          var query = input ? input.value : '';
          fixThumbnails(resultsEl, query);
        } catch (e) {
          // never break the search dropdown
        }
      });
      observer.observe(resultsEl, { childList: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
